// extracted by mini-css-extract-plugin
module.exports = {"container":"trustpilot-score_container__MH6MB","trustpilotStars":"trustpilot-score_trustpilotStars__zSClC","trustpilotLogo":"trustpilot-score_trustpilotLogo__loo49"};